import { useContext } from "react";
import { AppContext } from "../../context/AppContext";
// import { ZAFClient } from "zendesk_app_framework_sdk";

let zendeskClient;
export let ZenDesk_Embedded = {
  service: "Zendesk",
  showSideBar: true,
  showSideBarForcefully: true,
  inboxSendSMS: false,
  sideBarExtend: {
    customModuleTab: false,
  },
  workFlowIconInTemplates: true,
  loadScripts: function () {
    return new Promise((resolve, reject) => {
      resolve("https://static.zdassets.com/zendesk_app_framework_sdk/2.0/zaf_sdk.min.js");
    });
  },
  init: function (setAppProperties) {
    return new Promise((resolve, reject) => {
      if (!window?.ZAFClient) {
        console.error(" ZenDesk Embedded SDK not found. Make sure the app is running within Zen Desk.");
        return;
      }
      let client = window?.ZAFClient?.init();
      zendeskClient = client;
      try {
        if (client) {
          client.on("app.registered", function (context) {
            if (setAppProperties) {
              setAppProperties((prev) => {
                return { ...prev, loadedSDK: client };
              });
            }
          });
        }
        var topBarClientPromise = client.get("instances").then(function (instancesData) {
          var instances = instancesData.instances;
          for (var instanceGuid in instances) {
            if (instances[instanceGuid].location === "top_bar") {
              return client.instance(instanceGuid);
            }
          }
        });

        // called from another location using the instances API.
        topBarClientPromise.then(function (topBarClient) {
          // trigger an incoming_call event on the top bar
          topBarClient.invoke("preloadPane");

          if (client) {
            client.on("voice.dialout", function (data) {
              const callToNumber = data?.number;
              const contextName = data?.from;

              let associatedObjectId = null;
              let associatesObjectType = null;

              if (data?.ticketId) {
                associatedObjectId = data?.ticketId;
                associatesObjectType = "tickets";
              } else if (data?.userId) {
                associatedObjectId = data?.userId;
                associatesObjectType = "contacts";
              }

              if (callToNumber && setAppProperties) {
                setAppProperties((prev) => ({
                  ...prev,
                  callerNumber: callToNumber,
                  callRecordId: associatedObjectId,
                  callRecordModule: associatesObjectType,
                  callType: "outbound",
                }));
                ZenDesk_Embedded.showCallNotification(client, "outbound", setAppProperties);
              }
            });
          }
        });

        client.context().then(function (context) {});
        client.metadata().then(function (metadata) {
          var metaDataSettings = metadata.settings;
          resolve();
        });
      } catch (error) {
        // console.log("error >>>>>>", error);
        resolve();
      }
    });
  },
  getUserData: function () {
    return new Promise((resolve, reject) => {
      let client = zendeskClient;
      if (!client) {
        // client = window?.ZAFClient.init();
      }

      var fetchSelf = {
        url: "/api/v2/users/me.json",
        type: "GET",
        dataType: "json",
      };
      if (client) {
        client.request(fetchSelf).then(function (data) {
          client.context().then(function (context) {
            var companyDomain = "https://" + context.account.subdomain;
            var fullCompanyDomain = companyDomain + ".zendesk.com";
            var userData = {
              companyId: fullCompanyDomain,
              companyOrgId: data?.user?.organization_id,
              userId: data?.user?.id,
              email: data?.user?.email,
              product: "Omni",
              domainName: fullCompanyDomain,
            };
            resolve(userData);
          });
        });
      }
    });
  },
  getAssociatedObjectId: function (appProperties) {
    return new Promise((resolve, reject) => {
      let client = appProperties?.loadedSDK;
      if (!client) {
        // client = window?.ZAFClient?.init();
      }
      if (client) {
        client.get("currentLocation").then(function (data) {
          if (data.currentLocation.includes("ticket")) {
            client.get("ticket.id").then(function (data) {
              resolve(data["ticket.id"] + "");
            });
          } else if (data.currentLocation.includes("user")) {
            client.get("user.id").then(function (data) {
              resolve(data["user.id"] + "");
            });
          }
        });
      }
    });
  },
  getAssociatedObjectType: function (appProperties) {
    return new Promise((resolve, reject) => {
      let client = appProperties?.loadedSDK;
      if (!client) {
        // client = window?.ZAFClient?.init();
      }
      if (client) {
        client.get("currentLocation").then(function (data) {
          if (data.currentLocation.includes("ticket")) {
            resolve("Tickets");
          } else if (data.currentLocation.includes("user")) {
            resolve("Customers");
          } else {
            resolve("General");
          }
        });
      }
    });
  },
  fetchContact: function (fetchData, appProperties, phoneFieldConfiguration) {
    return new Promise(async (resolve, reject) => {
      let client = appProperties?.loadedSDK;
      if (!client) {
        // client = window?.ZAFClient?.init();
      }
      if (client) {
        client
          .get("ticket")
          .then(async function (data) {
          const ticketObj = data.ticket;
          const responseFinal = await fetchContactFromZenDesk(fetchData, appProperties, phoneFieldConfiguration, ticketObj);
          resolve(responseFinal);
        })
          .catch(function (error) {
            reject(error);
          });
      }
    });
  },
  showCallNotification: function (zendeskAppInstance, callState, setAppProperties) {
    return new Promise((resolve, reject) => {
      let client = zendeskAppInstance;
      if (!client) {
        // client = window?.ZAFClient?.init();
      }
      if (client) {
        var topBarClientPromise = client.get("instances").then(function (instancesData) {
          var instances = instancesData.instances;
          for (var instanceGuid in instances) {
            if (instances[instanceGuid].location === "top_bar") {
              return client.instance(instanceGuid);
            }
          }
        });
        topBarClientPromise.then(function (topBarClient) {
          topBarClient.invoke("popover");
          resolve();
        });
      }
    });
  },
  hideCallNotification: function (pipedriveSDK) {
    return new Promise((resolve, reject) => {
      resolve();
    });
  },
};
async function fetchContactFromZenDesk(fetchData, appProperties, phoneFieldConfiguration, ticketObj) {
  try {
    const numbersList = [];
    const {
      primaryPhoneApiName,
      secondaryPhoneApiName,
      secondaryPhoneTwoApiName,
      primaryPhoneLookUp,
      secondaryPhoneLookUp,
      secondaryPhoneTwoLookUp,
    } = phoneFieldConfiguration?.data?.config || {};

    const hasAssociatedModule = primaryPhoneLookUp || secondaryPhoneLookUp || secondaryPhoneTwoLookUp;

    if (hasAssociatedModule) {
      return await getAllAssociatedModulesPhoneRecords(
        primaryPhoneLookUp,
        secondaryPhoneLookUp,
        secondaryPhoneTwoLookUp,
        ticketObj,
        primaryPhoneApiName,
        secondaryPhoneApiName,
        secondaryPhoneTwoApiName,
        numbersList,
        appProperties
      );
    } else {
      return assemblePhoneRecords(ticketObj, primaryPhoneApiName, secondaryPhoneApiName, secondaryPhoneTwoApiName, numbersList);
    }
  } catch (err) {
    console.error("Error in fetchContactFromZenDesk:", err);
    throw err;
  }
}
function assemblePhoneRecords(recordObj, primaryPhoneApiName, secondaryPhoneApiName, secondaryPhoneTwoApiName, numbersList) {
  const recordInfoObj = { id: recordObj.id, module: "tickets" };

  const phoneFields = [primaryPhoneApiName, secondaryPhoneApiName, secondaryPhoneTwoApiName].filter(Boolean).filter((field) => recordObj[field]);

  if (phoneFields.length > 0) {
    recordInfoObj.phone = recordObj[phoneFields[0]];
    numbersList.push(recordInfoObj);
  }
  return numbersList;
}

async function getAllAssociatedModulesPhoneRecords(
  primaryPhoneLookUp,
  secondaryPhoneLookUp,
  secondaryPhoneTwoLookUp,
  ticketObj,
  primaryPhoneApiName,
  secondaryPhoneApiName,
  secondaryPhoneTwoApiName,
  numbersList,
  appProperties
) {
  try {
    const lookups = [
      { lookup: primaryPhoneLookUp, apiName: primaryPhoneApiName },
      { lookup: secondaryPhoneLookUp, apiName: secondaryPhoneApiName },
      { lookup: secondaryPhoneTwoLookUp, apiName: secondaryPhoneTwoApiName },
    ];

    for (const { lookup, apiName } of lookups) {
      if (!lookup) continue;

      const module = "users";
      if (!module) continue;

      const recordId = ticketObj["requester"]?.id;
      if (!recordId) continue;

      try {
        let client = appProperties?.loadedSDK;
        if (!client) {
          // client = window?.ZAFClient?.init();
        }
        if (client) {
          var fetchRecord = {
            url: `/api/v2/${module}/${recordId}.json`,
            type: "GET",
            dataType: "json",
          };

          let recordData = await client.request(fetchRecord);
          if (recordData) {
            const record = recordData?.user;
            const phoneValue = record?.[apiName];

            if (phoneValue) {
              numbersList.push({ id: recordId, module, phone: phoneValue });
            }
          }
          return numbersList;
        }
      } catch (err) {
        console.error(`Error fetching ${lookup} record:`, err);
      }
    }
  } catch (error) {
    console.error("Error in getAllAssociatedModulesPhoneRecords:", error);
    return numbersList;
  }
}
